function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  fill: "#004152",
  fillRule: "evenodd",
  d: "M.652 4.682c-.36 0-.652.291-.652.651v5.678c0 .37.306.67.677.67.363 0 .663-.294.663-.657 0-.363.295-.658.658-.658h12.038c.363 0 .658.297.658.66 0 .361.292.656.653.656.36 0 .653-.293.653-.654v-4.03c0-.366-.297-.664-.664-.664-.367 0-.664.298-.664.665v.574c0 .552-.448 1-1 1H2.304c-.553 0-1-.448-1-1v-2.24c0-.36-.292-.651-.652-.651zm4.467 3.482c-.597 0-1.096-.561-.736-1.036.309-.406.782-.633 1.381-.637 2.097-.016 4.193-.017 6.29 0 .62.005 1.126.275 1.425.712.315.462-.166.961-.726.961H5.119zM1.782 7.25c.012.56.449.971 1.025.964.557-.006 1.005-.45 1.004-.995 0-.566-.472-1.004-1.06-.987-.57.016-.98.448-.969 1.018z",
  clipRule: "evenodd"
});

var SvgBed = function SvgBed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bed.1fa7bb77.svg";
export { ForwardRef as ReactComponent };